export enum MppMediaItemType {
  IMAGE = 'image',
  VIDEO = 'video',
}
